var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadable-component",style:({
  width: _vm.loaderWidth && _vm.loading ? _vm.loaderWidth.toString().concat('px') : '100%',
  height: _vm.loaderHeight && _vm.loading ? _vm.loaderHeight.toString().concat('px') : '100%'
})},[(!_vm.loading)?_vm._t("default"):(!_vm.invisible)?_c('v-skeleton-loader',{class:'fill-height fill-width '.concat(_vm.loaderClass),attrs:{"type":_vm.loaderType,"width":_vm.loaderWidth,"height":_vm.loaderHeight}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }